import React from 'react';
import Types from 'prop-types';
import requiredIf from 'react-required-if';
import { FormattedMessage } from 'react-intl';
import { ChevronRight as Chevron } from '@transferwise/icons';
import { useTheme } from '@wise/components-theming';
import classNames from 'classnames';
import Badge from '../../../../../common/Badge';
import isActiveLink from '../../../../../../../common/utils/isActiveLink';
var linkPointsToSamePage = function linkPointsToSamePage() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return link.charAt(0) === '#';
};
var DropdownImage = function DropdownImage(_ref) {
  var image = _ref.image,
    imageRebrand = _ref.imageRebrand,
    itemId = _ref.itemId;
  var _useTheme = useTheme(),
    isModern = _useTheme.isModern;
  var imgUrl = isModern ? imageRebrand : image;
  if (imgUrl) {
    return /*#__PURE__*/React.createElement("img", {
      className: classNames("".concat(itemId, " tw-public-nav__dropdown-image visible-lg visible-xl"), isModern ? 'm-b-1' : 'm-b-3'),
      src: imgUrl,
      alt: ""
    });
  }
  return null;
};
DropdownImage.defaultProps = {
  image: '',
  imageRebrand: '',
  itemId: ''
};
var DropdownItem = function DropdownItem(_ref2) {
  var titleTranslationKey = _ref2.titleTranslationKey,
    titleTranslatedText = _ref2.titleTranslatedText,
    descriptionTranslationKey = _ref2.descriptionTranslationKey,
    image = _ref2.image,
    imageRebrand = _ref2.imageRebrand,
    link = _ref2.link,
    badge = _ref2.badge,
    activePath = _ref2.activePath,
    className = _ref2.className,
    itemId = _ref2.itemId,
    onCloseMenu = _ref2.onCloseMenu,
    isPillNavigation = _ref2.isPillNavigation;
  return /*#__PURE__*/React.createElement("li", {
    className: className
  }, /*#__PURE__*/React.createElement(WithLink, {
    link: link,
    onCloseMenu: onCloseMenu
  }, /*#__PURE__*/React.createElement(DropdownImage, {
    imageRebrand: imageRebrand,
    image: image,
    itemId: itemId
  }), /*#__PURE__*/React.createElement("strong", {
    className: classNames({
      'tw-link-with-chevron': !!link,
      'text-info': isActiveLink(link, activePath)
    })
  }, titleTranslationKey && /*#__PURE__*/React.createElement(FormattedMessage, {
    id: titleTranslationKey
  }), titleTranslatedText && /*#__PURE__*/React.createElement("span", null, titleTranslatedText), link && /*#__PURE__*/React.createElement(Chevron, {
    className: "tw-link-with-chevron-icon"
  })), descriptionTranslationKey && !isPillNavigation && /*#__PURE__*/React.createElement("p", {
    className: "m-t-1 m-b-0 visible-lg visible-xl tw-public-nav__dropdown-description"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: descriptionTranslationKey
  })), badge && ' ', badge && /*#__PURE__*/React.createElement(Badge, {
    translationKey: badge
  })));
};
function WithLink(_ref3) {
  var link = _ref3.link,
    onCloseMenu = _ref3.onCloseMenu,
    children = _ref3.children;
  if (link) {
    return /*#__PURE__*/React.createElement("a", {
      href: link,
      target: linkPointsToSamePage(link) ? '_self' : undefined,
      className: "callout-container tw-public-nav__dropdown-content"
      // Close the nav on mobile when a dropdown item link is clicked.
      // This is so same page links with `#` show up correctly for the user instead of hiding behind the nav.
      ,
      onClick: onCloseMenu
    }, children);
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "callout-container tw-public-nav__dropdown-content --no-link"
  }, children);
}
WithLink.defaultProps = {
  onCloseMenu: function onCloseMenu() {}
};
DropdownItem.defaultProps = {
  descriptionTranslationKey: undefined,
  image: undefined,
  imageRebrand: undefined,
  badge: '',
  activePath: undefined,
  className: '',
  itemId: '',
  onCloseMenu: function onCloseMenu() {},
  isPillNavigation: undefined
};
export default DropdownItem;